var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunity = function SvgCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M18 33c1.027 2 4.752 6 11.44 6s9.827-4 10.56-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M32.5 14.5C37.043 9.3 42.745 7.173 49 10c5.359 2.422 9.402 9.854 5.359 20.796C50.316 41.738 35.983 47.209 28.903 54c-7.621-7.703-20.944-10.895-24.16-24.572-3.132-13.32 3.946-22.31 15.431-20.067 11.485 2.244 10.107 15.46 10.107 15.46"
  })));
};
export default SvgCommunity;